<template lang="pug">
  b-container(fluid)
    b-row.page-wrap
      b-col(cols="6", v-if="group")
        //- 그룹 정보
        b-card.w-100(no-body)
          div(slot="header") {{$t('group')}}{{$t('information')}}
          b-list-group(flush)
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('name')}}
                b-col(cols="9")
                  template(v-if="group.name !== 'ROOT'")
                    editable(
                      name="name",
                      :value="group.name",
                      :wait="wait.name",
                      @changed="valueChange"
                    )
                  template(v-else)
                    editable(
                      name="name",
                      :value="$t('reserved.ROOT')",
                      :wait="wait.name",
                      @changed="valueChange"
                    )
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('manager')}}
                b-col(cols="9")
                  editable(
                    name="create_manager_name",
                    :value="group.create_manager_name",
                    :wait="wait.create_manager_name",
                    @changed="valueChange"
                    :disabled="true"
                  )
        
        //- 그룹 접근 권한 사용자 목록
        b-card.w-100.mt-3(no-body)
          div(slot="header") {{$t('list-of', {v: $t('user-in-group')})}}
            b-btn.ml-3.setting-btn(size="sm" variant="secondary" @click="showDialogUser = true" ) {{$t('add_user')}}
          b-list-group(flush)
            b-card.table-card
              b-table(
                ref="groupUserTable",
                :fields="fields",
                :items="userList",
                sort-by="userType",
                :sort-desc="false",
              )
                template(v-slot:cell(remove)="row")
                  b-button(size="sm", @click="removeUserFromGroup(row.item)")
                    icon(name="minus")

      b-col(cols="6")
        b-card-group(deck)
          //- 그룹에 속한 원격기기 목록
          b-card.w-100(no-body)
            div(slot="header") {{$t('list-of', {v: $t('device-in-group')})}}
            b-list-group(flush)
              b-list-group-item.device-filter
                b-input-group.mx-1.w-100(size="sm" @keyup.enter="setFilterValue")
                  template(slot="prepend")
                    b-dropdown(:text="$t(filters.key.text)", size="sm", variant="grey-200")
                      b-dropdown-item(
                        v-for="opt in filters.keyOptions",
                        :key="opt.value",
                        :style="{'font-size':'small'}",
                        @click="setFilterKey(opt)") {{$t(opt.text)}}
                  b-col
                    b-form-input(
                      v-if="filters.key.value === 'alias'",
                      v-model="filterPreValue")
                    b-form-select(
                      v-model="filterPreValue",
                      v-else-if="filters.key.value === 'dev_os_id'",
                      style="font-size: 14px;"
                      :options="filters.osOptions")
                    b-form-select(
                      v-model="filterPreValue",
                      v-else-if="filters.key.value === 'alive'",
                      style="font-size: 14px;"
                      :options="filters.statusOptions")
                  b-input-group-append
                    b-btn(size="sm", variant="secondary", @click="setFilterValue") {{ $t('search') }}

              b-list-group-item(
                style="height: 65px",
                v-for="dev in inGroupDev", :key="dev.pk")
                  div.d-flex.w-100.justify-content-between
                    div
                      div(v-html="dev.alias", :class="dev._role ? dev._role : 'dev'")
                      small {{dev.user_id}}
                    div
                      b-btn(size="sm", v-if="!dev._role", @click="removeDevFromGroup(dev)")
                        icon(name="minus")

            div(slot="footer")
              b-pagination(
                size="sm",
                style="justify-content: center",
                v-model="page.inGroup.current",
                :total-rows="page.inGroup.total",
                :per-page="page.per")
          
          //- 그룹 접근 권한 사용자가 등록한 원격기기 목록
          b-card.w-100(no-body)
            div(slot="header" style="letter-spacing: -0.8px") {{$t('groups_page.group_access_user_remote_device_list')}}
            b-list-group(flush)
              b-list-group-item.device-filter
                b-input-group.mx-1.w-100(size="sm" @keyup.enter="setSelfDevFilter")
                  template(slot="prepend")
                    b-dropdown(:text="$t(selfDevFilters.key.text)", size="sm", variant="grey-200")
                      b-dropdown-item(
                        v-for="opt in selfDevFilters.keyOptions",
                        :key="opt.value",
                        :style="{'font-size':'small'}",
                        @click="setSelfDevFilterKey(opt)") {{$t(opt.text)}}
                  b-col
                    b-form-input(
                      v-if="selfDevFilters.key.value === 'alias'",
                      v-model="selfDevPreFilter")
                    b-form-select(
                      v-model="selfDevPreFilter",
                      v-else-if="selfDevFilters.key.value === 'dev_os_id'",
                      style="font-size: 14px;"
                      :options="selfDevFilters.osOptions")
                    b-form-select(
                      v-model="selfDevPreFilter",
                      v-else-if="selfDevFilters.key.value === 'alive'",
                      style="font-size: 14px;"
                      :options="selfDevFilters.statusOptions")
                  b-input-group-append
                    b-btn(size="sm", variant="secondary", @click="setSelfDevFilter") {{ $t('search') }}
              b-list-group-item(
                style="height: 65px",
                v-for="dev in selfDev", :key="dev.pk")
                  div.d-flex.w-100.justify-content-between
                    div
                      div(v-html="dev.alias", :class="dev._role ? dev._role : 'dev'")
                      small {{dev.user_id}}
                    div
                      b-btn(size="sm", v-if="!dev._role", @click="addDevToGroup(dev)")
                        icon(name="plus")
                  //- icon.float-right.add-button(v-if="!dev._role", name="plus", @click="addDevToGroup(dev)")
            div(slot="footer")
              b-pagination(
                size="sm",
                style="justify-content: center",
                v-model="page.all.current",
                :total-rows="page.all.total",
                :per-page="page.per")

    dialog-manager(
      :show.sync="showDialogUser"
      :title="String($t('add_user'))"
      :data="{ context: 'group_users_list_modal', groupData: group }"
      @select="selectManager"
    )
</template>

<script>
import _ from "lodash"
import store from "@/api/store"
import Switches from "vue-switches"
import { DeviceListAPI, DeviceGroupAPI, ConnAPI, ConnUsersAPI, ConnDeviceGroupAPI } from "../../api"
import Editable from "../mixins/editable"
import DialogManager from "@/components/dialogs/dialogManager.vue"

export default {
  name: "groupdetail-component",
  components: { Editable, Switches, DialogManager },
  props: {
    groupPk: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    inGroupDev() {
      let devs = _.cloneDeep(this.groupAgentList)
      if (this.filters.value !== null) {
        devs = _.filter(devs, v => {
          let value = this.filters.value
          if (typeof value === "number") return v[this.filters.key.value] === value
          else {
            if (!v[this.filters.key.value]) return false
            return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
          }
        })
      }
      let offset = this.page.per * (this.page.inGroup.current - 1)
      devs = _.slice(devs, offset, offset + this.page.per)
      if (devs.length === 0) devs.push({ pk: "no-dev-msg", alias: this.$t("no-content"), _role: "empty" })
      if (devs.length < this.page.per) {
        while (devs.length !== this.page.per) {
          devs.push({ pk: Math.random(), alias: "&nbsp;", _role: "blank" })
        }
      }
      return devs
    },
    selfDev() {
      let devs = _.cloneDeep(this.selfAgentList)
      devs = _.filter(
        devs,
        v =>
          !_.includes(
            _.map(
              this.groupAgentList.filter(item => item.guid),
              "guid",
            ),
            v.guid,
          ),
      )
      if (this.selfDevFilters.value !== null) {
        devs = _.filter(devs, v => {
          let value = this.selfDevFilters.value
          if (typeof value === "number") return v[this.selfDevFilters.key.value] === value
          else {
            if (!v[this.selfDevFilters.key.value]) return false
            return _.includes(v[this.selfDevFilters.key.value].toUpperCase(), value.toUpperCase())
          }
        })
      }
      let offset = this.page.per * (this.page.all.current - 1)
      devs = _.slice(devs, offset, offset + this.page.per)
      if (devs.length === 0) devs.push({ pk: "no-dev-msg", alias: this.$t("no-content"), _role: "empty" })
      if (devs.length < this.page.per) {
        while (devs.length !== this.page.per) {
          devs.push({ pk: Math.random(), alias: "&nbsp;", _role: "blank" })
        }
      }
      return devs
    },
  },
  created() {
    this.fetchGroupAgent()
    this.fetchSelfAgent()

    this.getData()
    this.getUserList()
  },
  data() {
    return {
      showDialogUser: false,
      groupAgentList: [],
      selfAgentList: [],

      devices: [],
      groups: [],
      group: null,
      context: null,
      wait: {
        name: false,
        manager_name: false,
        dev_limit: false,
      },
      userList: null,
      connectedPk: null,
      threshold: {
        fields: [
          { key: "OS", label: `${this.$t("device")} ${this.$t("type")}` },
          { key: "Type", label: `${this.$t("alert")} ${this.$t("type")}` },
          {
            key: "Time",
            label: `${this.$t("progress")} ${this.$t("time")}(${this.$t("minute")})`,
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "Threshold",
            label: this.$t("limit"),
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "del",
            label: this.$t("delete"),
            thClass: "text-center",
            tdClass: "text-center",
          },
        ],
      },
      addThreshold: {
        devType: {
          value: null,
          options: [
            { value: "windows", text: "windows" },
          ],
        },
        alertType: {
          value: null,
          options: [
            { value: { number: "1", allow: 1 }, text: "Disconnected" },
            { value: { number: "2", allow: 2 }, text: "CPU Usage", allow: 2 },
            { value: { number: "3", allow: 2 }, text: "Memory Usage", allow: 2 },
            { value: { number: "4", allow: 2 }, text: "Disk Usage", allow: 2 },
            { value: { number: "5", allow: 2 }, text: "CPU Temperature", allow: 2 },
            { value: { number: "6", allow: 2 }, text: "Disk Temperature", allow: 2 },
            { value: { number: "7", allow: 2 }, text: "Fan Speed", allow: 2 },
          ],
        },
        thTime: { value: null },
        thValue: { value: null },
      },
      page: {
        per: 10,
        inGroup: {
          current: 1,
          total: 0,
        },
        all: {
          current: 1,
          total: 0,
        },
        userInGroup: {
          current: 1,
          total: 0,
        },
      },
      fields: [
        { key: "part", label: this.$t("department"), sortable: false },
        { key: "name", label: this.$t("name"), sortable: false },
        { key: "mgrid", label: this.$t("ID"), sortable: false },
        { key: "user_type", label: this.$t("permission"), sortable: false },
        { key: "remove", label: this.$t('delete'), sortable: false },
      ],
      filterPreValue: null,
      selfDevPreFilter: null,
      filters: {
        key: { value: "alias", text: "device_name" },
        keyOptions: [
          { value: "alias", text: "device_name" },
          { value: "dev_os_id", text: "O/S" },
          { value: "alive", text: "status" },
        ],
        value: null,
        osOptions: [
          { value: 1, text: "Windows" },
          { value: 2, text: "Linux" },
          { value: 3, text: "MacOS" },
          { value: 4, text: "Android" },
        ],
        statusOptions: [
          { value: 1, text: "Online" },
          { value: 0, text: "Offline" },
        ],
      },
      selfDevFilters: {
        key: { value: "alias", text: "device_name" },
        keyOptions: [
          { value: "alias", text: "device_name" },
          { value: "dev_os_id", text: "O/S" },
          { value: "alive", text: "status" },
        ],
        value: null,
        osOptions: [
          { value: 1, text: "Windows" },
          { value: 2, text: "Linux" },
          { value: 3, text: "MacOS" },
          { value: 4, text: "Android" },
        ],
        statusOptions: [
          { value: 1, text: "Online" },
          { value: 0, text: "Offline" },
        ],
      },
    }
  },
  methods: {
    fetchGroupAgent() {
      ConnAPI.get(`agent/${this.groupPk}`).then(res => {
        this.groupAgentList = res.data.objects

        this.page.inGroup.total = this.groupAgentList.length
      })
    },
    fetchSelfAgent() {
      ConnAPI.get(`agent/${this.groupPk}`, { params: { request_type: "all" } }).then(res => {
        this.selfAgentList = res.data.objects

        this.page.all.total = this.selfAgentList.length
      })
    },
    addThresholdHandler() {
      const values = this.addThreshold
      let params = {
        update_key: "alert",
        alert_time: 0,
      }
      if (!values.devType.value) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "please_select_device_type" },
        })
        return
      } else params.alert_code = "I" + values.devType.value.charAt(0).toUpperCase()

      if (!values.alertType.value) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "please_select_alert_type" },
        })
        return
      } else {
        params.alert_code += values.alertType.value.number
        const allow = values.alertType.value.allow
        if (allow === 1) {
          if (!values.thTime.value) {
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: "please_input_alert_time" },
            })
            return
          } else {
            // params.alert_th_value = 0
            params.alert_time = values.thTime.value
          }
        } else if (allow === 2) {
          if (!values.thValue.value) {
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: "please_input_alert_value" },
            })
            return
          } else {
            params.alert_th_value = values.thValue.value
          }
        }
      }
      DeviceGroupAPI.put(`${this.groupPk}`, params).then(resp => {
        this.getData()
      })
    },
    removeThresholdHandler(item) {
      let params = {
        context: {
          path: "delete_threshold",
        },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: "delete",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        let params = { delete_key: item.key }
        DeviceGroupAPI.put(`${this.groupPk}`, params).then(resp => {
          this.getData()
        })
      })
    },
    getUnit(key) {
      if (_.includes(key, "Temperature")) return "℃"
      else if (_.includes(key, "Speed")) return "rpm"
      return "%"
    },
    getUser() {
      const stored = store.get("devices")
      if (stored) {
        this.groups = stored.groups
        let grs = _.filter(this.groups, { pk: this.groupPk })
        if (grs.length == 0) {
          this.page.userInGroup.total = 0
        } else {
          this.page.userInGroup.total = grs[0].users.length
        }
      }
    },
    removeDevFromGroup(dev) {
      let params = {
        device_fk: dev.pk,
        group_fk: dev.device_group_fk,
      }
      DeviceListAPI.delete("", { params }).then(res => {
        this.$awn.success(this.$t("removed_device_in_group"))
        this.fetchGroupAgent()
      })
    },
    addDevToGroup(dev) {
      let params = {
        device_fk: dev.pk,
        group_fk: this.group.pk,
      }
      DeviceListAPI.post("", params)
        .then(res => {
          this.fetchGroupAgent()
          this.$awn.success(this.$t("added_device_in_group"))
        })
        .catch(err => {
          this.$awn.warning(err.response.data.objects.error)
        })
    },
    getData() {
      DeviceGroupAPI.get(`${this.groupPk}`).then(resp => {
        this.group = resp.data.objects
        this.threshold.list = this.group.IW
      })
    },
    putData(key, value) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      // deviceGroupAPI.put()
    },
    getUserList() {
      ConnUsersAPI.get(`${this.groupPk}`).then(resp => {
        this.userList = resp.data.objects
        this.userList.map(item => {
          if (item.user_type === 1) {
            item.user_type = this.$t('user')
          } else if (item.user_type === 2 || item.user_type === 3) {
            item.user_type = this.$t('policy_manager')
          } else if (item.user_type === 6) {
            item.user_type = this.$t('mid_manager')
          } else {
            item.user_type = "-"
          }
        })
      })
    },
    valueChange(key, value) {
      this.group[key] = value
      let params = {}
      params[key] = value
      DeviceGroupAPI.put(`${this.group.pk}`, params).then(resp => {
        store.update("devices", ({ groups }) => {
          let index = _.findIndex(groups, { pk: this.group.pk })
          groups[index][key] = value
          this.group[key] = value
          this.$awn.success(this.$t("changed_group_info"))
        })
      })
    },
    removeUserFromGroup(user) {
      let params = {
        title: "LinkMeMine",
        context: { path: "delete_user_confirm" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        let params = {
          device_group_fk: this.group.pk,
          member_fk: user.pk,
        }
        ConnDeviceGroupAPI.get("", { params }).then(resp => {
          this.connectedPk = resp.data.objects[0].pk
          ConnDeviceGroupAPI.delete(`${this.connectedPk}`).then(resp => {
            DeviceGroupAPI.get("").then(resp => {
              this.groupList = resp.data.objects
              this.fetchGroupAgent()
              this.fetchSelfAgent()
              this.$awn.success(this.$t("user_in_group_remove_success"))
              this.getUserList()
              this.$refs.groupUserTable.refresh()
            })
          })
        })
      })
    },
    groupDetailUserList(ctx) {
      return DeviceGroupAPI.get(`${this.groupPk}`).then(resp => {
        this.group = resp.data.objects
        this.group.user.map(item => {
          if (item.userType === 1) {
            item.userType = this.$t('user')
          } else if (item.userType === 2) {
            item.userType = this.$t('policy_manager')
          } else if (item.userType === 3) {
            item.userType = this.$t('policy_manager')
          } else if (item.userType === 6) {
            item.userType = this.$t('mid_manager')
          } else {
            item.userType = "-"
          }
        })
        this.threshold.list = this.group.IW
        return this.group.user
      })
    },
    setFilterKey(opt) {
      this.filters.value = null
      this.filterPreValue = null
      this.filters.key = opt
    },
    setFilterValue() {
      this.filters.value = this.filterPreValue
    },
    setSelfDevFilterKey(opt) {
      this.selfDevFilters.value = null
      this.selfDevPreFilter = null
      this.selfDevFilters.key = opt
    },
    setSelfDevFilter() {
      this.selfDevFilters.value = this.selfDevPreFilter
    },
    selectManager(users) {
      const params = {
        name: users.map(u => u.mgrid),
        member_fk: users.map(u => u.pk),
        device_group_fk: this.groupPk,
      }
      ConnDeviceGroupAPI.post("", params).then(res => {
        this.showDialogUser = false
        if (res.status === 200) {
          this.fetchGroupAgent()
          this.fetchSelfAgent()
          this.$awn.success(this.$t("user_in_group_add_success"))
          this.getUserList()
          this.$refs.groupUserTable.refresh()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.row,
.col,
.container-fluid,
.col-12 {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 0.5rem;
}

.device-filter {
  padding-left: 4px;
}

.card {
  border-radius: 0;
  &.table-card {
    border: 0;
  }
  > .card-header {
    border-bottom: 1px solid #d2d2d2;
    font-size: 0.9rem;
    font-weight: 500;
  }
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.setting-btn {
  height: 1.3rem;
  line-height: 0.9;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

::v-deep .b-table {
  margin: 0;

  tr,
  td,
  th {
    padding: 0.75rem 1.25rem;
    position: relative;
    font-weight: 400;
  }

  th:nth-child(1),
  th:nth-child(2),
  th:nth-child(3),
  th:nth-child(4),
  th:nth-child(5) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 20% !important;
  }

  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6f6f6f;
  }

  td button {
    /* icon 요소에 대한 스타일 */
    position: absolute;
    top: 50%; /* td의 50% 높이에 위치하도록 설정 */
    transform: translateY(-50%); /* 위에서 설정한 top 값만큼 위로 이동하여 가운데 정렬 */
    /* icon 요소에 대한 스타일을 추가로 설정 */
  }
}

::v-deep .form-control,
.custom-select {
  display: flex;
  background-color: #ffffff !important;
  border: 1px solid #6f6f6f !important;
  border-radius: 0;
  height: 1.75rem;
  align-items: center;
  text-align: left !important;
}
.b-pagination {
  margin-bottom: 0;
}
</style>
